module.exports = __webpack_public_path__ + "static/media/bg1.3ccc1f73.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_139/images/bg1.png
// module id = 1327
// module chunks = 0